export const cameraNames = [
  { abbreviation: 'FHAZ', Name: 'Front Hazard Avoidance Camera' },
  { abbreviation: 'RHAZ', Name: 'Rear Hazard Avoidance Camera' },
  { abbreviation: 'MAST', Name: 'Mast Camera' },
  { abbreviation: 'CHEMCAM', Name: 'Chemistry and Camera Complex' },
  { abbreviation: 'MAHLI', Name: 'Mars Hand Lens Imager' },
  { abbreviation: 'MARDI', Name: 'Mars Descent Imager' },
  { abbreviation: 'NAVCAM', Name: 'Navigation Camera' },
]
